import './scrollable.scss';
import React  from 'react';
import PropTypes from 'prop-types';
import utils from '../../utils/Utils';

// Cachear toggle functions para evitar JSON.parse en cada render
let _cachedToggle = null;
function getCachedToggle() {
  if (!_cachedToggle) {
    _cachedToggle = utils.getToggleFunctionsFromMetadata();
  }
  return _cachedToggle;
}

function Scrollable(props) {
  const hasTransition = getCachedToggle().transition;
  const className = hasTransition
    ? `transition-active scroller-container invisible-scrollbar ${props.className}`
    : `scroller-container invisible-scrollbar ${props.className}`;
  return (
    <div style={{ height: props.height, width: props.width }}
         className={className}>
      { props.children }
    </div>
  )
}

Scrollable.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};

Scrollable.defaultProps = {
  className: '',
  height: '100%',
  width: '100%'
};

export default Scrollable;



// WEBPACK FOOTER //
// ./src/components/Scrollable/index.jsx